module.exports = __webpack_public_path__ + "static/img/yyh.52e59a1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qrCode/yyh.png
// module id = WGgS
// module chunks = 2